goog.provide('el8.appchart.dialog.order.lab');

goog.require('el8.app.shared.dialog.createLabOrderTest');
goog.require('el8.appchart.dialog.order.addLabOrderSet');
goog.require('el8.appchart.dialog.order.util');
goog.require('el8.appchart.dialog.order.viewLabOrderSets');
goog.require('el8.appchart.permissions');
goog.require('el8.appshared.dialog.editPatient');
goog.require('el8.appshared.labVendorSplitting');
goog.require('el8.appshared.listeditorOpts');
goog.require('el8.appshared.mindreaderOpts');
goog.require('el8.data.base');
goog.require('el8.data.imos');
goog.require('el8.data.labOrderTests');
goog.require('el8.data.labVendors');
goog.require('el8.data.practiceUsers');
goog.require('el8.data.referencedPracticians');
goog.require('el8.practicedata.labVendorIntegrations');
goog.require('el8.practicedata.facilityIdentifiers');
goog.require('el8.ptdata.model.order');
goog.require('el8.ptdata.documentReminders');
goog.require('el8.template.appchart.dialog.order.lab');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.uiwidget.Icd10ListEditor');
goog.require('el8.util.amplitude.helpers');
goog.require('el8.util.amplitude.orderHelpers');
goog.require('el8.util.consts');
goog.require('el8.util.string');


el8.appchart.dialog.order.lab = (function() {
    var _selectedVendor = null;
    var _selectedVendorIntegrationEOrders = null;
    var _currOrder = null;
    var _userModified = false; //used to decide if we should save as draft on close (X)
    var _needXwalkOrderSet = null;
    var _orderSetId = null;
    var _saveCallbackFn = null;
    var _discardCallbackFn = null;


    var that = new el8.uiwidget.FormDialog({
        title: 'Lab Requisition Form',
        autoHeight: true,
        autoPosition: true,
        position: 'center',
        testId: 'lab-order-dialog',
        width: 575,
        closeFn: function() {
            if (_userModified) {
                that._saveAsDraft({minimize: false});
            } else {
                that.hide(); //don't make annoying blank drafts
                // weird case where we are going to log a 'complete lab' event
                // directly to Amplitude instead of going through logCompleteOrder
                el8.util.amplitude.logEvent('complete lab', {'action': 'Discard'} );
            }
        },
        minimizeFn: function() {
            that._saveAsDraft({minimize: true});
        },
        contentFn: function() {
            var vendors = el8.practicedata.labVendorIntegrations.sortedWithoutOrdersLive();
            var facilityIds = el8.practicedata.facilityIdentifiers.sortedAsSoyMaps();
            vendors = facilityIds.concat(vendors); // Have facility ids go before lab vendors

            return el8.template.appchart.dialog.order.lab.content({
                vendors: vendors,
                fastingMethods: el8.data.fastingMethods,
                billTypes: el8.data.billTypes,
                defaultBillType: el8.data.defaultBillType,
                reminderAssignees: el8.data.practiceUsers.getAssigneesInWorkspace()
            });
        }
    });

    var form = null;
    // keeping state of what current vendor/facility id is selected
    that._vendorId = null;
    that._facilityId = null;

    that._updateSelectedVendorIntegrationEOrders = function(vendorId) {
        // Check if we can eOrder, if so run validation
        // if not allow any set to be applied to this order
        var filteredVendorIntegrations = el8.practicedata.labVendorIntegrations.all().filter(function(integration) {
            return vendorId && integration.getLabVendorId() === vendorId;
        });
        _selectedVendorIntegrationEOrders = filteredVendorIntegrations.length === 1
          ? filteredVendorIntegrations[0].isOrdersIntegrationIsLive() : false;
        return _selectedVendorIntegrationEOrders;
    };

    that._createForm = function() {
        var that = this;
        var leOpts = that._createListeditorOpts();
        var fields = [
            {
                name: 'collectionTime',
                selector: ':input[name="collectionTime"]',
                timePickerOpts: {
                    increment: 1
                }
            },
            {
                name: 'collectionDate',
                selector: ':input[name="collectionDate"]',
                datePickerOpts: {},
                changeFn: function (){ },
            },
            {
                name: 'vendorId',
                selector: ':input[name="vendorId"]'
            },
            {
                name: 'siteId',
                selector: ':input[name="siteId"]'
            },
            {
                name: 'reminderUserOrGroup',
                selector: '.reminder-user-or-group'
            },
            {
                name: 'specialInsuranceName',
                selector: ':input[name="specialInsuranceName"]',
                infoText: 'SB name',
                maxLength: 64
            },
            {
                name: 'specialInsuranceCode',
                selector: ':input[name="specialInsuranceCode"]',
                infoText: 'SB code',
                maxLength: 5

            },
            {
                name: 'reminderDate',
                selector: ':input[name="reminderDate"]',
                datePickerOpts: {minDate: el8.service.tz.today()},
                infoText: 'no reminder'
            },
            {
                name: 'facilityId',
                selector: ':input[name="facilityId"]'
            }
        ];

        var _rest = [
            {
                name: 'statPhone',
                selector: ':input[name="statPhone"]'
            },
            {
                name: 'statFax',
                selector: ':input[name="statFax"]'
            },
            {
                name: 'tests',
                selector: ':input[name="tests"]',
                infoText: 'order sets or tests to be completed...',
                maxLength: 256,
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                listeditorOpts: leOpts.tests
            },
            {
                name: 'dxs-le',
                selector: '.billing-dxs-container',
                // Note: the "show dual coding" checkbox is shown and managed by the widget by default
                icd10ListeditorOpts: {
                    onImoSelectFn: function (icd10Le, item, mleIndex) {
                        if (item.imo_code) {
                            var imo = el8.data.imos.getByKey(item.imo_code);
                            imo.getAsBillDxMaps().forEach(function(dxMap) {
                                icd10Le.addNewEntry(dxMap);
                            });
                        } else if (item.model_class === 'ICD10Code') {
                            var icd10 = el8.data.icd10Codes.create(item);
                            icd10Le.addNewEntry({
                                icd10Code: icd10.asSoyMap()
                            });
                        }
                    },
                    onAddEntry: function() { that.adjustHeight(); },
                    onRemoveEntry: function() { that.adjustHeight(); },
                    index: null // only one LE
                }
            },
            {
                name: 'fastingMethod',
                selector: ':input[name="fastingMethod"]'
            },
            {
                name: 'dateForTest',
                selector: ':input[name="dateForTest"]',
                datePickerOpts: {},
                changeFn: function (){ $('[name=collectionTime]', that.getContentElt()).val(""); },
                infoText: 'do test on...'
            },
            {
                name: 'copyTo',
                selector: ':input[name="copyTo"]',
                infoText: 'copies of test results to...',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                maxLength: 111,
                listeditorOpts: leOpts.ccs
            },
            {
                name: 'billType',
                selector: ':input[name="billType"]'
            },
            {
                name: 'testCenterNotes',
                selector: ':input[name="testCenterNotes"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: 'instructions to test center..'
            },
            {
                name: 'followUpMethod',
                selector: ':input[name="followUpMethod"]',
                infoText : 'notify patient of results by...',
                mindreaderOpts: {
                    data: el8.data.followUpMethods,
                    entryHeight: 25
                },
                maxLength: 100
            },
            {
                name: 'standingOrderFrequency',
                selector: ':input[name="standingOrderFrequency"]',
                infoText: 'frequency...',
                maxLength: 50
            },
            {
                name: 'standingOrderEndDate',
                selector: ':input[name="standingOrderEndDate"]',
                datePickerOpts: {},
                infoText: 'end date...'
            }
        ];

        fields = fields.concat(_rest);


        fields.push({
            name: 'confidential'
        });

        form = new el8.uiwidget.Form({
            fields: fields
        });

        if (el8.appchart.permissions.allow('signOrders')) {
            var printButtonText, signButtonText, eOrderButtonText, eOrderAndPrintButtonText;
            if (el8.data.currUser.getOrderDelegatingPhysicianIdsInWorkspace().length) {
                eOrderButtonText = 'eOrder on behalf of physician';
                eOrderAndPrintButtonText = 'eOrder & Print on behalf of physician';
                printButtonText = 'Print on behalf of physician';
                signButtonText = 'Sign on behalf of physician';
            } else {
                eOrderButtonText = 'eOrder';
                eOrderAndPrintButtonText = 'eOrder & Print';
                printButtonText = 'Print & Close';
                signButtonText = 'Sign & Close';
            }

            // NOTE: the e-order buttons will be shown or hidden
            // based on if LC is the currently selected vendor or not
            form.addButton('eorder-and-close', eOrderButtonText, function() {
                that._saveAndClose({print: false, eOrder: true, action: eOrderButtonText});

            },true);
            form.addButton('eorder-print-and-close', eOrderAndPrintButtonText, function() {
                that._saveAndClose({print: true, eOrder: true, action: eOrderAndPrintButtonText});
            },true);

            form.addButton('print-and-close', printButtonText, function() {
                that._saveAndClose({print: true, action: printButtonText});
            }, true);
            form.addButton('save-and-close', signButtonText, function() {
                that._saveAndClose({action: signButtonText});

            }, false);
        }

        form.addButton('save-draft', 'Save as Draft & Close', function() {
            that._saveAsDraft({minimize: false});
        }, false);

        form.addDiscardButton(function() {
            form.disable();
            that._extractOrder(_currOrder);
            el8.util.amplitude.logCompleteOrder(_currOrder, 'Discard', null);
            that._deleteOrder(_currOrder, function() {
                that.hide();
                if (_discardCallbackFn) {
                    _discardCallbackFn();
                }
            });
        }, false);

        that.setForm(form);
    };

    that._createListeditorOpts = function() {
        var testMindreaderOpts = el8.appshared.mindreaderOpts.labOrderTestsSets();

        $.extend(testMindreaderOpts, {
            modifyRenderCb: function (params) {
                if (_selectedVendor && _selectedVendorIntegrationEOrders) {
                    params.actionsDiv.hide();  // "Create a new test with this name"
                } else {  // Vendor reset to none or one w/o compendium
                    params.actionsDiv.show();
                }
            },
            selectFn: function(event, item) {
                var TEST_LIMIT = 40;
                var isSet = el8.model.idToModelClass(item.id) === 'LabOrderSet';
                var numEntriesInSet = 0;
                var form = that.getForm();
                var numEntries = form.getListeditor('tests').numEntries();

                if (isSet) {
                    var orderSet = el8.data.labOrderSets.getById(item.id);
                    numEntriesInSet = orderSet.getTestIds().length;
                }
                if (numEntries === TEST_LIMIT || numEntries + numEntriesInSet > TEST_LIMIT) {
                    el8.uiwidget.nonAlarmingAlert('You are attempting to add more than 40 tests.\nTo add more tests please create a new order.');
                    return;
                }

                if (!isSet) { that._selectOrderTest(item.id); }
                else { that._selectOrderSet(item.id, 'Test Search'); }
            },
            formatSelected: function(item) {
                return null; // Don't use this to populate; use the selectFn callbacks instead
            },
            emptyQueryText: 'Displaying order sets...',
            emptyQueryData: function() {
                return el8.data.labOrderSets.all().filter(function(labOrderSet) {
                    // No tests? No show
                    if (!labOrderSet.getTests().length) {
                        return false;
                    }

                    // If there's no selected vendor or that vendor doesn't have a order
                    // compendium, show all the non-vendor sets otherwise
                    // show only the selected (compendium-having) vendor's sets.
                    if (!_selectedVendor) {
                        return true;
                    }

                    // E2E Orders v1
                    // If the selected vendor is an in-house vendor, then only include sets
                    // that are associated with the in-house vendor id
                    if (el8Globals.FEATURES.InHouseLabWorkflow && _selectedVendor.isIsInHouse()) {
                        return labOrderSet.rawData.lab_vendor_id === _selectedVendor.getId();
                    }
                    
                    // Selected vendor doesn't have a compendium, show non-vendor specific sets
                    if (!_selectedVendor.isHasOrderCompendium()) {
                        return !labOrderSet.getLabVendorId();
                    }

                    // We know now that the selected vendor has one or more order compendiums,
                    // the question is now, is the set in the compendium specified by the
                    // selected _facility id_? This is needed for multiple compendium support

                    // If there is NOT a current compendium in the fid obj, show all sets
                    // that are for this specific vendor (else clause). Otherwise show only
                    // sets that contain tests from the current compendium
                    var fidobj = that._getFacilityIdObject();
                    if (fidobj) {
                        var currentCompendiumId = fidobj.getCompendiumId();
                        if (!currentCompendiumId) {
                            // Can't select a compendium, show all sets from this vendor
                            return _selectedVendor.getId() === labOrderSet.getLabVendorId();
                        }

                        if (labOrderSet.getTests()[0].getCompendiumId() === currentCompendiumId) {
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        // Can't select a compendium, show all sets from this vendor
                        return _selectedVendor.getId() === labOrderSet.getLabVendorId();
                    }

                    // Fallback is to return the set
                    return true;

                }).map(function(s) {
                    return s.asAutocompleteMap();
                });
            },
            noRepeatEmptyQuery: true,
            url: function() {
                // Use compendiumId from facilityIdentifier if exists to search
                var facilityIdObj = that._getFacilityIdObject();
                var compendiumId = facilityIdObj ? facilityIdObj.getCompendiumId() : null;

                // E2E Orders v1
                if (
                    !compendiumId && 
                    el8Globals.FEATURES.InHouseLabWorkflow && 
                    _selectedVendor && 
                    _selectedVendor.isIsInHouse()
                ) {
                    var vendorDefaultCompendiumId = that._getVendorDefaultCompendiumId();
                    compendiumId = vendorDefaultCompendiumId? vendorDefaultCompendiumId : null;
                };

                // Since we don't have a compendium id and no way to get it,
                // we can't query with it.
                return el8.service.urls.get('searchLabOrderTestsSets', [compendiumId]);

            },
            actions: [
                {
                    name: 'Create a new test with this name...',
                    actionFn: function(val) {
                        // Even if the "Create a new test with this name" div
                        // is hidden it's possible to select it with the keyboard
                        // because of the code of the mindreader. That would be
                        // very hard to change so block at this point as well.
                        if (_selectedVendor && _selectedVendorIntegrationEOrders) {
                           return;
                        }

                        that._promptForTest(val);
                    }
                }
            ]
        });

        var testLeOpts = el8.appshared.listeditorOpts.labOrderTests();
        $.extend(testLeOpts, {
            list: function() {
                return $('#lab-order-tests-list', that.getContentElt());
            },
            addEntryFn: function() { that.adjustHeight(); },
            handleStringEntryFn: function(val) {
                // Don't prompt to add a new test if the selected vendor has a compendium
                if (_selectedVendor && !_selectedVendor.isHasOrderCompendium()) {
                    that._promptForTest(val);
                }
            },
            mindreaderOpts: testMindreaderOpts
        });

        // Sets up AOE display
        $.extend(testLeOpts, {
            nestingSpec: {
                'labels': 'questions',
                'responses': 'answers',
                'labelCode': 'code',
                'labelValue': 'value',
                'labelType': 'questionType',
                'maxLength': 'maxLength',
                'choices': 'choices',
                'choiceCode': 'code',
                'choiceValue': 'value',
                'responseValue': 'responseValue'
            }
        });

        var ccLeOpts = {
            list: function() {
                return $('#lab-order-ccs-list', that.getContentElt());
            },
            editFriendly: true,
            labelType: 'medium',
            addEntryFn: function() { that.adjustHeight(); },
            convertTextToItemFn: function(text) {
                var item = el8.data.referencedPracticians.getByName(text, 'fullName');
                return item || text;
            },
            getItemTextFn: function(item) {
                return (item.getFullName) ? item.getFullName() : item.name;
            },
            getItemIdFn: function(item) {
                return (item.getId) ? item.getId() : item.id;
            },
            mindreaderOpts: el8.appshared.mindreaderOpts.physicians({
                listeditorFriendly: true,
                newContactCb: function(contact) {
                    form.getListeditor('copyTo').addEntry(contact);
                }
            })
        };

        return {
            tests: testLeOpts,
            ccs: ccLeOpts
        };
    };

    var super_init = that._init;
    that._init = function() {
        that._createForm();
        that._fetchData(); // fetch data first before init()
        super_init.call(that);

        that.getDialogContainer().attr('id', 'new-lab-order-dialog-container');
        that._bindTriggers();
        that._initDetailsDiv();

        that.getContentElt().on('click', '.check-medicare-eligibility',  function() {
            that._extractOrder(_currOrder, true);

            var error = '';
            if (!_currOrder.getTestIds() || _currOrder.getTestIds().length === 0) {
                error = 'Please enter at least one test.';
                el8.uiwidget.alert(error);
                el8.util.amplitude.logEvent('check lab medicare eligibility', {'error': error});
            } else if ((!_currOrder.getIcd10Ids() || _currOrder.getIcd10Ids().length === 0) && (!_currOrder.getIcd9Ids() || _currOrder.getIcd9Ids().length === 0)) {
                error = 'Please input at least one valid diagnosis code.';
                el8.uiwidget.alert(error);
                el8.util.amplitude.logEvent('check lab medicare eligibility', {'error': error});
            } else {
                var labName = _selectedVendor.getName();
                var service = '';
                var pdf_url = '';
                if (labName.toLocaleLowerCase().includes('labcorp')) {
                    service = 'checkLabcorpABN';
                    pdf_url = 'labcorpABNPDF';
                } else if (labName.toLocaleLowerCase().includes('quest')
                  || labName.toLocaleLowerCase().includes('care360')) {
                    service = 'checkQuestABN';
                    pdf_url = 'questABNPDF'
                } else {
                    error = 'Could not determine the proper ABN service. Lab name: ' + labName;
                    el8.uiwidget.alert(error);
                    el8.util.amplitude.logEvent('check lab medicare eligibility', {'error': error});
                    return;
                }
                that.getContentElt().find('.checking-medicare-eligibility').show();
                that.getContentElt().find('.medicare-coverage').hide();
                $.el8_ajax({
                    type: 'GET',
                    url: el8.service.urls.get(service),
                    data: {
                        icd10code_id: _currOrder.getIcd10Ids(),
                        icd9code_id: _currOrder.getIcd9Ids(),
                        test_id: _currOrder.getTestIds(),
                        facility_id: _currOrder.getFacilityId(),
                        order_id: _currOrder.getId()
                    },
                    success: function(data) {
                        that.getContentElt().find('.checking-medicare-eligibility').hide();
                        that.getContentElt().find('.medicare-coverage').replaceWith(
                            $(el8.template.appchart.dialog.order.lab.medicareCoverage({
                                success: data['success'],
                                needsAbn: data['is_abn_required'],
                                cost: data['est_cost']/100,
                                abnPdfUrl: el8.service.urls.get(pdf_url, [data['pdf']])
                            }))
                        );
                        var eventProperties = {};
                        if (!data['success']) {
                            eventProperties.error = 'Unable to check ' + labName + ' ABN service. Please try again later.';
                        }
                        el8.util.amplitude.logEvent('check lab ' + labName + ' medicare eligibility', eventProperties);
                    },
                    error_msg: function(responseCode, defaultMsg) {
                        that.getContentElt().find('.checking-medicare-eligibility').hide();
                        var errorMessage = defaultMsg;
                        if (responseCode >= 400) {
                            var eventProperties = {};
                            eventProperties.error = 'Unable to check ' + labName + ' ABN service. Please try again later.';
                            errorMessage = eventProperties.error;
                        }
                        el8.util.amplitude.logEvent('check lab ' + labName + ' medicare eligibility', eventProperties);
                        return errorMessage;
                    }
                });
            }
        });
    };

    var super_hide = that.hide;
    that.hide = function() {
        // remove relevant event listeners
        that.getContentElt().off('focus', ':input:radio');
        that.getContentElt().off('blur', ':input:radio');
        that.getWarningElt().off('click', '.open-patient-insurance-trigger');

        _selectedVendor = null;
        _currOrder = null;
        _userModified = false;
        _orderSetId = null;
        // do NOT clear `_saveCallbackFn` or `_discardCallbackFn` back to null here.
        // the dialog gets hidden *before* the API calls' success handler fires.
        // if we clear the callbacks here, they will always be null when the respective
        // success handler runs and they will never get to do anything.

        super_hide.call(that);
    };

    that._createEorderInsuranceWarning = function() {
        that.getWarningElt().html(el8.template.appchart.dialog.order.lab.eorderInsuranceWarning());
        that.getWarningElt().on('click', '.open-patient-insurance-trigger',  function (e) {
            e.preventDefault();
            // We want to open both the patient demographics dialog and the patient insurance
            // dialog so that the user can update/save the insurance and e-order
            el8.appshared.dialog.editPatient.show({
                onSaveCallback: function() {
                    // our lab order form has some state that requires us knowing when a
                    // patient's insurance information changes (it's for labcorp e-order integration).
                    // This will force a state update to our order form
                    if (el8.appchart.dialog.order.lab.isOpen()) {
                        el8.appchart.dialog.order.lab._handleVendorOrBillTypeChange();
                    }
                }
            });
            // click the primary insurance link that adds/edits rather than the replace link
            el8.appshared.dialog.editPatient.getContentElt()
                .find('.edit-complex-insurance[data-label="Primary"]:not([data-type])')
                .click();
        });
    };

    var super_show = that.show;
    that.show = function(setLastPosition, spec) {
        spec = spec || {};

        _discardCallbackFn = spec.discardCallbackFn || null;
        _saveCallbackFn = spec.saveCallbackFn || null;

        function doShow() {
            super_show.call(that);
            // Hide xwalk notifier
            $('.needs-xwalk-container', that.getContainer()).hide();

            that.getContentElt().on('focus', ':input:radio',  function(e) {
                $(e.target).next('label').addClass('focus el8Medium');
            });
            that.getContentElt().on('blur', ':input:radio',  function(e) {
                $(e.target).next('label').removeClass('focus el8Medium');
            });
            that._createEorderInsuranceWarning();
            that._handleVendorOrBillTypeChange();
        }

        var model = spec.model;
        if (!model && spec.modelId) {
            model = el8.ptdata.labOrders.getById(spec.modelId);
        }

        if (model) {
            if (_currOrder) {
                // If form already populated, confirm before over-writing
                el8.uiwidget.confirm('Do you want to overwrite the contents of the active lab order form?',
                    function() {
                        that._saveAsDraft({
                            noHide: true,
                            successCb: function () {
                                _currOrder = model;
                                doShow();
                                that._populateForm(_currOrder);
                            }
                        });
                    },
                    function() { doShow(); }
                );
            } else {
                // we have nothing here yet, so just show the requested model
                _currOrder = model;
                doShow();
                that._populateForm(_currOrder);
            }

        } else {
            // if we don't have anything setup, open a blank form
            if (!_currOrder) {
                _currOrder = el8.ptdata.model.order.lab({
                    model_class: 'LabOrder',
                    is_on_hold: false,
                    document_date: el8.service.tz.now()
                });
                doShow();

                // let icd10LE manage showDualCoding (but the form needs to be init'd)
                var sdc = form.getIcd10Listeditor('dxs-le').getShowDualCoding();
                _currOrder.setShowDualCoding(sdc);
                that._setDefaults();
            }
            // if we already have a _currOrder, don't do anything
        }

        if (spec.orderSetId) {
            that._selectOrderSet(spec.orderSetId, 'Previously Created Order (???)'); // Not sure if this is ever used
        }

        // Make sure this is hidden
        that.getContentElt().find('.medicare-coverage').hide();

        // initialize what current vendor/facility id is
        that._vendorId = that._getVendorId();
        that._facilityId = that._getFacilityId();

        // Focus vendor select
        $(':input[name="vendorId"]', form.getContainer()).focusFocus();
    };

    that._setDefaults = function() {
        that._setVendorDefault();
        form.setVal('fastingMethod', 'fasting_random');
    };

    that._clearCollectionDateTime = function() {
        form.setVal('collectionTime', '');
        form.setVal('collectionDate', '');
    }

    that._fetchData = function() {
        // facility ids only relevant for eordering
        el8.practicedata.facilityIdentifiers.softLoad();
        el8.practicedata.labVendorIntegrations.softLoad();
        el8.data.labVendorPatientSites.softLoad();

        $.el8_ajax({
            type: 'GET',
            url: el8.service.urls.get('labOrderMetadata'),
            async: false,
            success: function(data) {
                el8.data.fastingMethods = data['fasting_methods'] || [];
                el8.data.statMethods = data['stat_methods'] || [];
                el8.data.billTypes = data['bill_types'] || [];
                el8.data.defaultBillType = data['default_bill_type'] || '';
            }
        });
        // this can be async since it will take the user some time to click into the tests mindreader
        // and we're only using it for mindreader emptyQueryData right now
        el8.data.labOrderSets.softLoad(null, true);
    };

    that._toggleReminders = function () {
        // remove el8EditorTextareaWrap on parent
        var $elt = that.getContentElt();
        $elt.find('.reminder-user-or-group-wrap').toggleClass('el8EditorTextareaWrap');
        // hide input
        $elt.find('.reminder-user-or-group').toggle();
        // update and unhide span
        $elt.find('.reminder-user-or-group-item').toggle();
        $elt.find('.reminder-user-or-group-remove-trigger').toggle();
    };

    /**
     * This is getting the model instance of FacilityIdentifier
     */
    that._getFacilityIdObject = function() {
        // will return object if exists else null
        return el8.practicedata.facilityIdentifiers.getById(form.getVal('vendorId') * 1, true);
    };

    /**
     * This is getting the ID of the FacilityIdentifier object
     */
    that._getFacilityId = function() {
        var facilityIdObject = that._getFacilityIdObject();
        if (facilityIdObject) {
            return facilityIdObject.getId();
        }

        return null;
    };

    /**
     * This is getting the LabVendor ID. We may need to get it from
     * FacilityIdentifier if that was selected for e-ordering
     */
    that._getVendorId = function() {
        // check if facility id exists (only for e-ordering)
        var facilityIdObject = that._getFacilityIdObject();
        if (facilityIdObject) {
            return facilityIdObject.getVendorId();
        }
        // ok there's no facility, return from form
        return form.getVal('vendorId') * 1;
    };

    that._getVendorDefaultCompendiumId = function() {
        var vendorId = that._getVendorId();
        var selectedVendor = el8.data.labVendors.getById(vendorId);
        return selectedVendor? selectedVendor.getDefaultLabCompendiumId(): null;
    };

    /**
     * This is getting the lab vendor integration associated with the selected vendor.
     * Will return null if one is not selected.
     *
     * @param {number} vendorId - passed in vendor id if we haven't selected one yet
     */
    that._getVendorIntegration = function(vendorId) {
        vendorId = vendorId || that._getVendorId();
        // no point getting integration if we haven't selected a vendor
        if (!vendorId) { return null; }

        // return the integration or null if we don't have it
        var filteredIntegrations = el8.practicedata.labVendorIntegrations.all().filter(function(integration) {
            return integration.getLabVendorId() === vendorId;
        });
        return filteredIntegrations.length === 1 ? filteredIntegrations[0] : null;
    };

    that._ordersIntegrationIsLive = function() {
        var vendorIntegration = that._getVendorIntegration();
        return Boolean(vendorIntegration && vendorIntegration.isOrdersIntegrationIsLive());
    };

    that._bindTriggers = function() {
        that.getContentElt().on('change', ':input[name="vendorId"]',  function(e) {
            // vendorId grabbed from form can be either LabVendor or FacilityIdentifier
            var facilityIdObject = that._getFacilityIdObject();
            var vendorId = that._getVendorId();

            if (facilityIdObject) {
                var facilityId = facilityIdObject.getId().toString();
                form.setVal('facilityId', facilityId);
            } else {
                form.setVal('facilityId', '');
            }

            that._selectVendor(vendorId);
            that._handleVendorOrBillTypeChange();

            if (!_selectedVendor) {
              $(':input[name="siteId"]', that.getContentElt()).prop('disabled', false);
              form.setVal('siteId', "");
            }
            return false;
        });

        // LabCorp eOrder only:
        // - Show a note to use special label paper if this is an in-house draw/specimen collection
        // - Show/hide ABN button and special billing fields when bill type is selected
        that.getContentElt().on('change', ':input[name="siteId"]',  function(e) {
            var siteId = form.getVal('siteId');
            var dateForTest = $('[name=dateForTest]', that.getContentElt());
            var collectionTimeSection = $('.collection-time-section', that.getContentElt());

            if (siteId === '0') { // 0 === in-house draw
                // only want to show special paper reminder if we have a live orders
                // integration with the selected vendor and it's an in house draw
                if (that._ordersIntegrationIsLive()) {
                    $('.special-paper-reminder', that.getContentElt()).show();
                } else {
                    $('.special-paper-reminder', that.getContentElt()).hide();
                }
                dateForTest[0].value = null;  // clear the value or it is recorded
                dateForTest.parent().hide();
                collectionTimeSection.show();
                var now = el8.service.tz.now();
                if (el8Globals.FEATURES.InHouseLabWorkflow && _selectedVendor && _selectedVendor.isIsInHouse()) {
                    that._clearCollectionDateTime();
                } else {
                    if (!form.getVal('collectionDate')) {
                        form.setVal('collectionDate', now.asString());
                    }
                    if (!form.getVal('collectionTime')) {
                        form.setVal('collectionTime', now.asTimeString());
                    }
                }
            } else { // "" === "any site" or int for a specific site
                $('.special-paper-reminder', that.getContentElt()).hide();
                dateForTest.parent().show();
                that._clearCollectionDateTime();
                collectionTimeSection.hide();
            }
            that.adjustHeight();
            return false;
        });
        that.getContentElt().on('change', ':input[name="billType"]',  function(e) {
            that._handleVendorOrBillTypeChange();
            return false;
        });

        that.getContentElt().on('keyup', '[name=testCenterNotes]',  function() {
            if (this.getAttribute("maxLength") > 0) {
                document.getElementById('testCenterNotesCount').innerHTML = "Characters left: " +
                    (this.getAttribute("maxLength") - this.value.length);
            }
        });
        that.getContentElt().on('keydown', ':input[type="text"]',  function() {
            // This is not an accurate measure of whether the form is "dirty"
            // but it's not terrible for a cheap solution
            _userModified = true;
        });
        that.getContentElt().on('click', '#view-order-sets-trigger',  function(e) {
            el8.util.amplitude.logEvent('view lab order sets');
            el8.appchart.dialog.order.viewLabOrderSets.show(true, function(orderSetId) {
                that._selectOrderSet(orderSetId, 'Order Set View');
            });
        });
        that.getContentElt().on('click', '#save-as-order-set-trigger',  function(e) {
            el8.appchart.dialog.order.addLabOrderSet.show({
                name: _needXwalkOrderSet ? _needXwalkOrderSet.getName() : null,
                saveCallbackFn: function(name, id) { that._saveOrderSet(name, id); }
            });
        });
        that.getContentElt().on('click', '#clear-collection-trigger',  function(e) {
            that._clearCollectionDateTime();
            el8.util.amplitude.logSpecimenCollectionCleared();
        });
        that.getContentElt().on('focus', '[name="collectionTime"]',  function(e) {
            if (!this.value) {
                $(this).timeEntry('setTime', null);
            }
        });
        that.getContentElt().on('click', '.fill-icd9-trigger',  function(e) {
            var mr = form.getMindreader('dxs');
            var code = $(this).attr('data-code'); // prevent conversion e.g. 250.00
            mr.setInputVal(code);
            mr.requestResults(code);
            $(':input[name="dxs"]', form.getContainer()).focusFocus();
        });
    };

    that._initDetailsDiv = function() {
        that._detailsTrigger = $('.order-form-details-trigger', that.getContentElt());
        el8.uiwidget.collapsible({
            container: $('.order-form-details-section', that.getContentElt()),
            triggerElt: that._detailsTrigger,
            statusElt: that._detailsTrigger,
            statusTextCollapse: 'more...',
            statusTextExpand: 'less...',
            collapseFn: function() { that.adjustHeight(); },
            expandFn: function() { that.adjustHeight(); }
        });
    };

    /**
     * Populating order sets
     * @param {string} source - indicates where in the app the order set was selected from (used solely for amplitude)
     */
    that._selectOrderSet = function(orderSetId, source) {
        var orderSet = el8.data.labOrderSets.getById(orderSetId);

        // check vendor match if vendor has compendium

        // we will block the order set if the selected vendor's compendium
        // is different from that of the selected order set
        var orderSetVendorId = orderSet.getLabVendorId();
        var orderSetVendor = orderSetVendorId && el8.data.labVendors.getById(orderSetVendorId);
        var eOrderAllowed = _selectedVendor
          ? that._updateSelectedVendorIntegrationEOrders(_selectedVendor.getId())
          : false;

        var blockOrderSet = _selectedVendor && _selectedVendor.isHasOrderCompendium() &&
        (_selectedVendor.getId() !== orderSetVendorId || !orderSetVendorId);

        // FUTURE: There's also the case of same vendor + different compendium.
        // That's probably rare enough not to need it's own blocking code.

        if (!blockOrderSet) {
            // also block if the selected vendor is unselected or has no compendium
            // but the order set is for a specific vendor
            blockOrderSet = _selectedVendor
              ? !_selectedVendor.isHasOrderCompendium() && orderSetVendorId
              : true && orderSetVendorId;
        }

        if (eOrderAllowed && blockOrderSet) {
            var eventProperties = {'source': source};
            var error;
            if (orderSet.getVendorName()) {
                error = "This order set for vendor (" + orderSet.getVendorName() + ") cannot be used with the selected vendor (" + _selectedVendor.getName() + ")";
                el8.uiwidget.alert(error);
            } else {
                error = "This order set cannot be used with selected vendor (" + _selectedVendor.getName() + ")";
                el8.uiwidget.alert(error);
            }
            eventProperties.error = error;
            el8.util.amplitude.logEvent('select lab order set', {'source': source, 'error': error});
            return;
        }
        el8.util.amplitude.logEvent('select lab order set', {'source': source});

        // show needs xwalk stuff
        if (!orderSet.getIcd10Ids().length && orderSet.getIcd9Ids().length) {
            $('.needs-xwalk-container', that._form.getContainer()).html(
                el8.template.appchart.dialog.order.lab.needsXwalk(
                   {icd9Codes: orderSet.getIcd9CodeObjs().map(function(icd9Obj) { return icd9Obj.getCode(); })}
                )
            ).show();

            $('#save-as-order-set-trigger', that._form.getContainer()).addClass('el8Bold el8StandardFontSize');
            _needXwalkOrderSet = orderSet;
            that.adjustHeight();
        }

        // insert 10s and 9s
        if (orderSet.getIcd10Ids()) {
            var icd9Maps = orderSet.getIcd9CodeObjs().map(el8.model.toSoyMapFn);
            orderSet.getIcd10CodeObjs().forEach(function(icd10, index) {
                form.getIcd10Listeditor('dxs-le').addNewEntry({
                    icd9Codes: index === 0 ? icd9Maps : [],
                    icd10Code: icd10.asSoyMap()
                },
                true // noFocus
                );
            });
        }

        // Update the vendor, if the order set has one
        if (eOrderAllowed || (blockOrderSet && !_selectedVendor)) {
            // First, if we already have a selected facilityId, do nothing
            var facilityId = that._getFacilityId();

            if (!facilityId) {
                // Now since we don't know the facilityId/vendor:
                // Find all the matching fids based from the orderset's vendor
                var facilityIds = el8.practicedata.facilityIdentifiers.all().filter(function(facilityIdentifier) {
                    return facilityIdentifier.getVendorName() === orderSetVendor.getName();
                });

                if (facilityIds.length === 1) {
                    // If there's only one, use it
                    var facilityId = facilityIds[0].getId();
                } else {
                    // If there's more than 1 that means this user has multiple
                    // facilities for a single vendor. This could occur when a
                    // user has two different accts or wants to use multiple
                    // compendiums for the same vendor.
                    //
                    // Here we'll get the orderset's compendium id from a
                    // test, then use that to find the correct facilityId
                    var test = orderSet.getTests()[0];
                    var facility = facilityIds.filter(function(fi) {
                        return fi.getCompendiumId() === test.getCompendiumId();
                    })[0]
                    facilityId = facility
                      ? facility.getId()
                      : orderSetVendorId;
                }
            }

            // This will trigger that._selectVendor(), which will
            // then lookup this 'vendorId' as a facilityId, then
            // set both correctly, before _selectVendor() is called...
            form.setVal('vendorId', facilityId);

        } else if (orderSetVendorId) {
            // This will kick off that._selectVendor(). Should NOT be a facilityId!
            form.setVal('vendorId', orderSetVendorId);
        }

        var _addTests = function () {
            if (orderSet.getTestIds()) {
                orderSet.getTests().map(function(t) {
                    that._clearQuestionResponses(t);
                    that._addEntry(t);
                    el8.util.amplitude.logEvent('select lab test', {'test name': t._name});
                });
            }
        }

        // We need to defer and add tests *after* vendor/facility is set by
        // setVal and _bindTriggers. Otherwise, _addEntry() etc. could be
        // using the old vendor/facility.
        // _.defer(_.bind(_addTests, this));
        _.defer(_addTests);

        _userModified = true;
        _orderSetId = orderSetId;
    };

    that._addEntry = function(test) {
        // Pull out the Quest-specific code to do test-level notes
        var vendor = el8.data.labVendors.getById(that._getVendorId());
        if (vendor && vendor.getName().toLowerCase().includes("care360") && that._ordersIntegrationIsLive()) {
            // perTestNote == true
            form.getListeditor('tests').addEntry(test, null, null, true);
        } else {
            form.getListeditor('tests').addEntry(test);
        }
    }

    that._selectOrderTest = function(testId) {
        var vendor = el8.data.labVendors.getById(that._getVendorId());
        var tests = form.getListeditor('tests').getAllEntries();
        var testSelected = el8.data.labOrderTests.getById(testId);

        // Labcorp splitting logic
        if (vendor && vendor.getName() === 'labcorp') {
            if (!el8.appshared.labVendorSplitting.labcorp(testSelected, tests)) {
                return; // prevent test addition
            }
        }

        // Quest splitting logic
        if (vendor && vendor.getName().toLowerCase().includes("care360") && that._ordersIntegrationIsLive()) {
            if (!el8.appshared.labVendorSplitting.quest(testSelected, tests)) {
                return;
            }
        }

        // Add the test
        el8.util.amplitude.logEvent('select lab test', {'test name': testSelected._name});
        that._clearQuestionResponses(testSelected);
        that._addEntry(testSelected);
    };

    /**
     *  Populating order form with draft order
     */

    that._populateForm = function(order) {
        if (!order) { return; }
        if (order.getDateForTest()) {
            form.setVal('dateForTest', order.getDateForTest().asString());
        }
        if (order.getCollectionDatetime()) {  // We never preserve in-house draw. Set it below
            var cDt = order.getCollectionDatetime();
            form.setVal('collectionDate', cDt.asString());
            form.setVal('collectionTime', cDt.asTimeString());
            form.setVal('siteId', 0);
        }

        form.setVal('fastingMethod', order.getFastingMethod());
        if (order.getStatMethod().toLowerCase().indexOf('phone') >= 0) {
            form.setVal('statPhone', true);
        }
        if (order.getStatMethod().toLowerCase().indexOf('fax') >= 0) {
            form.setVal('statFax', true);
        }

        var testIds = order.getTestIds() || [];
        var responseValues = {};
        testIds.forEach(function(testId) {
            responseValues[testId] = {};
        });


        // Create a responseValues dict from the persisted order's "answers"
        //
        // order -> [answers] -> {responseValues}
        order.getAnswers().forEach(function(answer) {
            var testId = answer.getTestId();
            var test = el8.data.labOrderTests.getById(testId);
            var questionId = answer.getQuestion().getId();


            if (responseValues[testId] !== undefined) {
                if ((answer.getQuestion().getQuestionType() === 'enum_multiselect' ||
                     test.getProcedureClass() === 'HI') &&
                    responseValues[testId][questionId] !== undefined) {
                    responseValues[testId][questionId] += '|' + answer.getValue();
                }
                else {
                    responseValues[testId][questionId] = answer.getValue();
                }
            }
        });

        // Now we have {responseValues} keyed by test & question, set the associated
        // responseValue. Then we fill in the responses to the questions for display
        for (var i=0; i<testIds.length; i++) {
            var test = el8.data.labOrderTests.getById(testIds[i]);
            var testQuestions = test.getQuestions();

            for (var j=0; j<testQuestions.length; j++) {
                var rvs = responseValues[testIds[i]];
                var value = rvs[testQuestions[j].getId()]
                testQuestions[j].setResponseValue(value || '');
            }

            // But this doesn't completely work for Quest since it has a test-level
            // notes since they are a hack based on "pseduo-questions" added in the
            // nestedListEditor. So at this point, we'll look for a persisted "note answer",
            // and if found, we'll hydrate a new AOEQuestion to feed to nestedListEditor
            // for display.
            var order_fid = el8.practicedata.facilityIdentifiers.getById(order.getFacilityId())

            if (order_fid && order_fid.getVendorName() === "care360") {

                // Find the answers for this test, then find any notes in those answers
                var _note_answers = order.getAnswers().filter(
                    function(answer) {
                        return (answer.getTestId() === test.getId()) &&
                               (answer.getQuestion().getCode() === el8.util.consts.NTE_PSEUDO_AOEQUESTION_CODE)
                })

                if (_note_answers.length) {
                    var new_question = el8.data.labOrderTests.AOEQuestion({
                        choices: [],
                        code: el8.util.consts.NTE_PSEUDO_AOEQUESTION_CODE,
                        id: null,
                        maxLength: 999,
                        questionType: "freetext",
                        responseValue: _note_answers[0].getValue() || "",
                        value: "NOTE"
                    })
                    testQuestions.unshift(new_question); // Always first in list
                }
            }

            that._addEntry(test);
        }

        if (order.getCcIds()) {
            var ccIds = order.getCcIds();
            for (var i=0; i<ccIds.length; i++) {
                var cc = el8.data.referencedPracticians.getById(ccIds[i]);
                form.getListeditor('copyTo').addEntry(cc);
            }
        }

        form.getIcd10Listeditor('dxs-le').repopulateFromIdLists({
            icd10Ids: order.getIcd10Ids(),
            icd9Ids: order.getIcd9Ids()
        }, true);

        // use facility id if exists
        if (order.getFacilityId()) {
            // setting both facility and vendor id as facility id so dropdown
            // matches can be chosen correctly
            form.setVal('facilityId', order.getFacilityId());
            form.setVal('vendorId', order.getFacilityId());
        } else {
            form.setVal('vendorId', order.getVendorId());
        }

        // only want to set site id if there's a vendor id
        if (order.getVendorId() && order.getSiteId()) {
            form.setVal('siteId', order.getSiteId());
        }

        var reminder = order.getReminder();
        if (reminder) {
            form.setVal('reminderUserOrGroup', reminder.getAssigneeId());
            form.setVal('reminderDate', reminder.getRemindDate().asString());
        }

        if (order.getTestCenterNotes() || order.getFollowUpMethod() ||
                order.getFollowUpMethod() || order.getBillType() ||
                order.getStandingOrderEndDate() || order.getStandingOrderFrequency()) {
            that._detailsTrigger.trigger('el8_expand');
        }
        form.setVal('testCenterNotes', order.getTestCenterNotes());
        form.setVal('followUpMethod', order.getFollowUpMethod());
        form.setVal('billType', order.getBillType());
        // set special billing code and name if they exist
        if (order.getBillType() === 'specialbilling') {
            form.setVal('specialInsuranceName', order.getSpecialInsuranceName() || '');
            form.setVal('specialInsuranceCode', order.getSpecialInsuranceCode() || '');
        }
        if (order.getStandingOrderEndDate()) {
            form.setVal('standingOrderEndDate', order.getStandingOrderEndDate().asString());
        }
        form.setVal('standingOrderFrequency', order.getStandingOrderFrequency());

        form.setVal('confidential', order.isConfidential());

    };
    that._setVendorDefault = function() {
        if (el8.ptdata.ptPreferences.getLabCenterVendorId()) {
            form.setVal('vendorId', el8.ptdata.ptPreferences.getLabCenterVendorId());
            if (el8.ptdata.ptPreferences.getLabVendorPatientSiteId()) {
                form.setVal('siteId', el8.ptdata.ptPreferences.getLabVendorPatientSiteId());
            }
        } else {
            var idToSet = el8.data.currUser.getDefaultLabVendorId() || el8.data.currUser.getDefaultLabFacilityId();
            if (idToSet) {
                form.setVal('vendorId', idToSet);
            }
        }
    };

    that._clearQuestionResponses = function(test) {
        // Have an unfortunate need to clear any previous responses from the
        // questions because they are essentially global state -- if we don't
        // do this, newly opened orders or added tests may be populated with
        // values persisting from a different order!
        test.getQuestions().forEach(function(question) {
            question.setResponseValue('');
        });
    };

    /**
     * Saving the order form
     */
    that._validate = function(order, saveFn) {
        var testIdsValidated = that._validateTestIds(order);
        if (!testIdsValidated.result) {
            return testIdsValidated;
        } else if (!order.getTestIds() || order.getTestIds().length === 0) {
            return { result : false, msg : 'Please input at least one test to order.' };
        } else if (!order.getVendorId()) {
            return { result : false, msg : 'Please select a vendor.' };
        } else if ((!order.getIcd10Ids() || order.getIcd10Ids().length === 0) && (!order.getIcd9Ids() || order.getIcd9Ids().length === 0)) {
            return { result : false, msg : 'Please input at least one valid diagnosis code.' };
        } else if (!el8.appchart.dialog.order.util.validatePrescribingUser(order)) {
            el8.appchart.dialog.selectPrescribingPhysician.show('orders', function(physicianId) {
                var practiceUser = el8.data.practiceUsers.getByStaffId(physicianId);
                order.setPrescribingUserId(practiceUser.getId());
                if (saveFn) { saveFn(); }
            });
            return {result: false, msg: ''}; // won't actually show an alert dialog
        } else if (!that._validateLabcorpMicrobiologySources(order)) {
            return { result : false, msg : 'When submitting multiple microbiology tests, the source must be the same for all tests.'};
        } else if (!that._validateEorderUsesFacility(order)) {
            return {result: false, msg: 'When submitting a LabCorp e-order, a facility must be specified in the Lab dropdown.'};
        } else if (order.getBillType() === 'specialbilling' && !that._validateLabcorpSpecialBillingFilledOut(order)) {
            return {result: false, msg: 'When submitting a LabCorp e-order with Special Billing selected, the billing name and code needs to be filled out.'};
        }

        return that._validateCcNames(order);
    };
    that._validateDraft = function(order) {
        var testIdsValidated = that._validateTestIds(order);
        if (!testIdsValidated.result) {
            return testIdsValidated;
        }
        return that._validateCcNames(order);
    };
    // this is just called by other validation functions
    that._validateCcNames = function(order) {
        var ccNames = order.getCcNames();
        for (var i=0, len=ccNames.length; i < len; i++) {
            if (!ccNames[i]) { continue; } //this happens when CC comes from autoselect

            var validated = el8.util.string.validatePhysicianNameLength(ccNames[i]);
            if (!validated.result) { return validated; }
        }

        return { result : true };
    };
    // this is just called by other validation functions
    that._validateTestIds = function(order) {
        var testIds = order.getTestIds();
        var testNames = order.getTestNames();
        for (var i=0, len=testIds.length; i < len; i++) {
            if (!testIds[i]) { //this happens when a test does not already exist
                var msg = 'Please replace "' + testNames[i] + '" with an existing test ' +
                          'or "Create a new test" for it from the dropdown.';
                return { result: false, msg: msg };
            }
        }
        return { result : true };
    };
    that._validateLabcorpMicrobiologySources = function(order) {
        var vendorId = order.getVendorId();
        if (vendorId) {
            var vendor = el8.data.labVendors.getById(vendorId);

            // Labcorp has restrictions on microbiology tests - they all have to be the same source
            if (vendor.getName() === 'labcorp') {
                var tests = order.getTests();
                var source = null;

                // For every microbiology test, check questions for source values
                for (var i=0; i<tests.length; i++) {
                    if (tests[i]) {
                        if (tests[i].getLabcorpProcedureClass() === 'microbiology') {
                            var questions = tests[i].getQuestions();

                            for (var j=0; j<questions.length; j++) {
                                var question = questions[j];

                                if (question.getCode().toUpperCase() === 'SOURCE') {
                                    if (!source) {
                                        source = question.getResponseValue();
                                    }
                                    else if (source !== question.getResponseValue()) {
                                        return false;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        return true;
    };

    that._validateEorderUsesFacility = function(order) {
        // we don't care if eorders isn't live, so we'll just say we pass validation
        if (!that._ordersIntegrationIsLive()) {
            return true;
        }

        // check that the e-order has an associated facility identifier
        return Boolean(order.getFacilityId());
    };

    that._validateLabcorpSpecialBillingFilledOut = function(order) {
        // we don't care if eorders isn't live, so we'll just say we pass validation
        if (!that._ordersIntegrationIsLive()) {
            return true;
        }

        // we want special billing to be completely filled out (code and name) for labcorp orders
        var vendor = el8.data.labVendors.getById(that._getVendorId());
        if (!vendor || (vendor.getName() === 'labcorp' && !(order.getSpecialInsuranceCode() && order.getSpecialInsuranceName()))) {
            return false;
        }
        return true;
    };

    that._extractOrder = function(order, isSignedOff) {
        that._setPrescribingUser(order);
        order.setOnHold(!isSignedOff);

        var mapped = form.getMapped();

        if (form.getVal('statPhone') && form.getVal('statFax')) {
            mapped['statMethod'] = 'stat_phone_fax'; // need to hard code because of our UI
        } else if (form.getVal('statPhone')) {
            mapped['statMethod'] = 'stat_phone'; // need to hard code because of our UI
        } else if (form.getVal('statFax')) {
            mapped['statMethod'] = 'stat_fax'; // need to hard code because of our UI
        } else {
            mapped['statMethod'] = null;  // RM-7283 reset this value for re-orders
        }
        /* For clarity, NULL out fields we don't want to populate */
        mapped['statPhone'] = null;
        mapped['statFax'] = null;
        mapped['tests'] = null;
        mapped['diagnoses'] = null;
        mapped['copyTo'] = null;
        mapped['showDualCoding'] = form.getIcd10Listeditor('dxs-le').getShowDualCoding(); // retrieve state from LE

        var assigneeId = form.getVal('reminderUserOrGroup');
        order.populate(_.extend(mapped, el8.data.practiceUsers.extractAssigneeObj(assigneeId)));

        var ccsWidget = form.getListeditor('copyTo');
        var ccs = ccsWidget.getAllEntries();
        var tests = form.getListeditor('tests').getAllEntries();

        var ccIds = [];
        var ccNames = [];
        ccs.map(function(a) {
            if (a.item) {
                var name = ccsWidget.getItemTextFn(a.item);
                var id = ccsWidget.getItemIdFn(a.item);
                if (name !== a.text) {
                    ccNames.push(a.text);
                    ccIds.push(null);
                } else {
                    ccIds.push(id);
                    ccNames.push(null);
                }
            } else {
                ccNames.push(a.text);
                ccIds.push(null);
            }
        });
        order.setCcIds(ccIds);
        order.setCcNames(ccNames);

        var testIds = [];
        var invalidTests = []; // we no longer want to automagically create lab tests

        // attach and push up the actual test objects on order (for AOE)
        var testObjs = [];

        tests.map(function(a) {
            if (a.item) {
                if (a.item.getNameWithCode() === a.text) {
                    testIds.push(a.id);
                    invalidTests.push(null); // but the API is maintaining testNames for consistency/safety for now
                } else {
                    testIds.push(null);
                    invalidTests.push(a.text);
                }
                testObjs.push(a.item);
            } else {
                testIds.push(null);
                invalidTests.push(a.text);
            }
        });
        order.setTestIds(testIds);
        order.setTestNames(invalidTests); // client should validate that these are all null

        order.setTests(testObjs);

        if (mapped.siteId === "0") { // only for in-house draw
            var collectDate = form.getVal('collectionDate');
            var collectTime = form.getVal('collectionTime');
            if (that._getVendorId()) {
                var vendor = el8.data.labVendors.getById(that._getVendorId());
                if (that._ordersIntegrationIsLive() && vendor.getName().toLowerCase().includes("labcorp")) {
                    // RM-7600 To reduce user 'friction' for LabCorp e-orders, if date/time not set,
                    // set to current date and/or time
                    if (!el8.service.tz._validateDate(el8.service.tz.processTimeInput(collectDate))) {
                        collectDate = new Date().toLocaleDateString();
                    }
                    if (!el8.service.tz._validateDate(el8.service.tz.processTimeInput(collectTime))) {
                        collectTime = new Date().toTimeString();  // 24-hr time
                    }
                }
            }
            order.setCollectionDatetime(el8.service.tz.processDateAndTimeInputs(collectDate, collectTime));
        } else {  // Clear any already-set value (re-orders)
            order.setCollectionDatetime(null);
        }

        // manually set vendor id to the correct value
        order.setVendorId(that._getVendorId());

        var icdIds = form.getIcd10Listeditor('dxs-le').getIcdIdLists();
        order.setIcd9Codes([]);
        order.setIcd9Descs([]);
        order.setIcd9Ids(icdIds.icd9Ids);
        order.setIcd10Ids(icdIds.icd10Ids);

        order.setOrderSetId(_orderSetId);
    };
    that._setPrescribingUser = function setPrescribingUser(model) {
        var currUser = el8.data.currUser;
        if (currUser.getOrderDelegatingPhysicianIdsInWorkspace().length) {
            var delegatingPhysicians = currUser.getOrderDelegatingPhysicianIdsInWorkspace();
            if (delegatingPhysicians.length === 1) {
                var practiceUser = el8.data.practiceUsers.getByStaffId(delegatingPhysicians[0]);
                model.setPrescribingUserId(practiceUser.getId());
            }
        } else if (currUser.isPhysician()) {
            model.setPrescribingUserId(currUser.getId());
        }
        // validation will be responsible for catching the case that there's > 1 delegating physician
    };
    that._saveOrder = function(order, doPrint, doEOrder, successCb) {
        var postMap = order.asMap();
        postMap['eorder'] = doEOrder ? true : false;

        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('postOrder', [order]),
            data: JSON.stringify(postMap),
            async: !doPrint,
            success: function(data) {
                order.populate(data);
                if (doPrint) {  // Call the endpoint that checks for/displays the PDF
                    window.open(el8.service.urls.get('printOrder', [order]));
                }
                el8.ptdata.labOrders.add(order);
                el8.appservice.notifier.notify(order.getNotifyText('SAVE_COMPLETE'));
                if (!order.isOnHold()) {  // Add to chart feed or to active visit note
                    el8.appchart.mgr.notes.addNewOrder(order);
                }

                if (order.getVendorId()) {  // Save per-pt vendor and site
                    el8.ptdata.ptPreferences.setLabCenterVendorId(order.getVendorId());
                }
                if (order.getSiteId()) {
                    el8.ptdata.ptPreferences.setLabVendorPatientSiteId(order.getSiteId());
                }

                if (successCb) { successCb(); }
                if (_saveCallbackFn) {
                    _saveCallbackFn(data);
                }

                if(el8Globals.FEATURES.BiDiLabs && order.getReminder()){
                    el8.util.amplitude.logSetOrderReminder('lab order');
                }
            },
            error: function() {
                form.enable();
            }
        });
    };
    that._deleteOrder = function(order, successCb) {
        if (order && order.getId() && order.isOnHold()) {
            el8.appservice.notifier.notify(order.getNotifyText('DELETE_IN_PROGRESS'));
            el8.ptdata.labOrders.deleteItem(order, false, {
                successCb: function() {
                    el8.appservice.notifier.notify(order.getNotifyText('DELETE_COMPLETE'));
                    form.reset();
                    form.enable();
                    if (successCb) { successCb(); }
                }
            });
        } else {
            el8.appservice.notifier.notify(order.getNotifyText('DELETE_COMPLETE'));
            form.reset();
            form.enable();
            if (successCb) { successCb(); }
        }
    };
    that._saveAndClose = function(spec) {
        spec = spec || {};
        form.disable();
        that._extractOrder(_currOrder, true);
        var saveFn = function() {
            that._saveOrder(_currOrder, spec.print, spec.eOrder, function() {
                that.hide();
            });
        };
        var validated = that._validate(_currOrder, saveFn);
        if (!validated.result) {
            el8.uiwidget.alert(validated.msg);
            form.enable();
        } else {
            saveFn();
        }
        el8.util.amplitude.logCompleteOrder(_currOrder, spec.action, validated.msg);
    };
    that._saveAsDraft = function(spec) {
        spec = spec || {};
        that._extractOrder(_currOrder, false);

        // grab order now in case it gets cleared by that.hide()
        var orderForAmplitude = _currOrder;

        // we care about this check because the form will break for over-long names
        var validated = that._validateDraft(_currOrder);
        if (!validated.result) {
            el8.uiwidget.alert(validated.msg);
            form.enable();
        } else {
            that._saveOrder(_currOrder, undefined, undefined, spec.successCb);
            if (spec.minimize) {
                el8.appchart.mgr.orderForm.renderOnHoldOrder(_currOrder);
            }
            if (!spec.noHide) {
                that.hide();
            }
        }
        el8.util.amplitude.logCompleteOrder(orderForAmplitude, 'Save As Draft & Close', validated.msg);
    };
    that._saveOrderSet = function(name, id) {
        that._extractOrder(_currOrder, false);
        var postDict = {
            name: name,
            icd9Ids: _currOrder.getIcd9Ids(),
            icd10Ids: _currOrder.getIcd10Ids(),
            testIds: _currOrder.getTestIds(),
            vendorId: _selectedVendor && _selectedVendor.isHasOrderCompendium() ? _selectedVendor.getId() : null
        };
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('labOrderSets', id ? [id] : null),
            data: JSON.stringify(postDict),
            success: function(data) {
                el8.appservice.notifier.notify('Lab order set saved.');
                el8.data.labOrderSets.create(data);
            }
        });
    };

    /**
     * HELPERS
     */
    that._selectVendor = function(vendorId) {
        var that = this;
        var _doSelect = function() {
            // initialize siteId here because it gets wiped by our replacing of the site options
            var siteId = form.getVal('siteId');
            _selectedVendor = el8.data.labVendors.getById(vendorId);
            that._updateSelectedVendorIntegrationEOrders(vendorId);

            // set options for the site dropdown
            var sites = el8.data.labVendorPatientSites.getByVendorId(vendorId);
            $(':input[name="siteId"]', that.getContentElt()).replaceWith(
                $(el8.template.appchart.dialog.order.lab.sitesSelect({
                    sites: sites.map(function(site) { return site.asSoyMap(); })
                }))
            );

            // we want to keep the currently selected ID if it's 0 (In House Draw)
            // or the site's vendor matches the currently selected vendor
            var matchingSites = sites.filter(function(site) {
                return site.getId().toString() === siteId;
            });
            form.setVal('siteId', siteId === "0" || matchingSites.length > 0 ? siteId : "");

            // if the vendor is in house vendor, automatically select In House Draw
            // and disable the dropdown
            if (_selectedVendor && _selectedVendor.isIsInHouse()) {
              form.setVal('siteId', '0');
              $(':input[name="siteId"]', that.getContentElt()).prop('disabled', true);
            }
        };

        /* If there are any vendor specific tests, we need to remove them */
        if (!form.getListeditor('tests').isEmpty()) {
            var tests = form.getListeditor('tests').getAllEntries();
            var vendorTests = [];

            var shouldRemoveItem = function(item) {
                // we want to remove in 2 situations:
                // 1. test has associated vendor that doesn't match currently selected vendor
                // 2. vendor integration has live order integration and test doesn't match vendor
                // NOTE: #2 will return true if test doesn't have associated vendor
                if (item.getVendorId() && item.getVendorId() !== vendorId) {
                    return true;
                }
                var vendorIntegration = that._getVendorIntegration(vendorId);
                if (vendorIntegration
                    && vendorIntegration.isOrdersIntegrationIsLive()
                    && item.getVendorId() !== vendorId) {
                        return true;
                    }
                    return false;
                };

            for (var i=0; i<tests.length; i++) {
                if (tests[i].item && shouldRemoveItem(tests[i].item)) {
                    vendorTests.push(tests[i].item);
                }
            }
            if (vendorTests.length) {
                var str = vendorTests.map(function(a) { return a.getName(); }).join(', ');
                el8.uiwidget.confirm(
                    (vendorTests.length === 1) ?
                        'There is one lab-specific test selected ('+str+'). '+
                        'If you change lab companies, the test will be removed. Proceed?' :
                        'There are '+vendorTests.length+' lab-specific tests selected ('+str+'). '+
                        'If you change lab companies, these tests will be removed. Proceed?',
                    function() { // if yes
                        var entries = vendorTests.map(function(a) {
                            return form.getListeditor('tests').getEntryById(a.getId());
                        });
                        for (var i=0; i<entries.length; i++) {
                            form.getListeditor('tests').removeEntry(entries[i]);
                        }
                        // set new current vendor/facility id
                        that._facilityId = that._getFacilityId();
                        that._vendorId = vendorId;
                        _doSelect();
                    },
                    function() {  // if no
                        // reset vendor id to old value so that we don't change the vendor
                        form.setVal('vendorId', that._facilityId ? that._facilityId : that._vendorId);
                    }
                );
                return;
            }
        }

        // set new current vendor/facility id
        that._vendorId = vendorId;
        that._facilityId = that._getFacilityId();
        // I might get called in a "change" event when vendorId === 0 (e.g. from the cdsDialog)
        // don't select in that case
        if (vendorId) {
            _doSelect();
        } else {  // RM-7443 - Need to update the LabOrderSetList to add "Create a new test..."
            _selectedVendor = null;
        }

    };

    that._hideEorderButtons = function () {
        form.hideButton('eorder-and-close');
        form.hideButton('eorder-print-and-close');
        form.showButton('print-and-close');
        form.showButton('save-and-close');
    };

    that._showEorderButtons = function () {
        form.showButton('eorder-and-close');
        form.showButton('eorder-print-and-close');
        form.hideButton('print-and-close');
        form.hideButton('save-and-close');
    };

    that.enableBillTypeByVendor = function (vendor) {
        /**
         * RM-7791 method fulfills the current spec that disables certain billing
         * selection options for e-ordering vendors that would otherwise be
         * rejected by the vendor or our HL7 parser. Since we don't currently
         * have proper feedback from our server-side HL7 parsing, we need to
         * duplicate some of this logic/feedback in the client.
         *
         * @type {string}
         */
        var billTypeDropdown = ':input[name="billType"]';
        if (that._ordersIntegrationIsLive()) {  // Selectively disable some bill types
            var lookupKey = "";
            var disabledBillTypesByVendor = {
                'care360': ['', 'specialbilling'],
                '': [],
            };
            if (vendor && vendor.getName() in disabledBillTypesByVendor) {
                lookupKey = vendor.getName();
            }
            $(billTypeDropdown + ' option').each(function(index, option) {
                $(option).prop('disabled', disabledBillTypesByVendor[lookupKey].indexOf(option.value) !== -1);
            });
            if ($(billTypeDropdown).find(':selected').prop('disabled')) {  // Disabled option is selected
                $(billTypeDropdown).find(':enabled').eq(1).prop('selected', true);  // Select 'Patient'
            }
        } else {  // Enable all bill types
            $(billTypeDropdown + ' option').each(function(index, option) {
                $(option).prop('disabled', false);
            });
        }
    };

    that._handleVendorOrBillTypeChange = function() {

        var vendorId = that._getVendorId();
        var vendor;
        if (vendorId) {
            vendor = el8.data.labVendors.getById(vendorId);
        }
        that.enableBillTypeByVendor(vendor);
        if (!vendor) {
            that.getContentElt().find('.special-ins-name').hide();
            that.getContentElt().find('.check-medicare-eligibility').hide();
            // hide and set height to 0 for adjusting the dialog height correctly
            that.getWarningElt().css('height', '0px').hide();
            that._hideEorderButtons();
        } else {
            var billType = form.getVal('billType');
            if (billType === "thirdparty"
                && vendor && vendor.rawData
                && vendor.rawData.results_integration_available === true) {
                that.getContentElt().find('.check-medicare-eligibility').show();
            } else {
                that.getContentElt().find('.check-medicare-eligibility').hide();
            }

            if (billType === "specialbilling") {
                // Initially hidden and want to be inline block, can't use plain .show()
                that.getContentElt().find('.special-ins-name').css('display', 'inline-block');
                that.getContentElt().find('.special-ins-code').css('display', 'inline-block');
            } else {
                that.getContentElt().find('.special-ins-name').hide();
                that.getContentElt().find('.special-ins-code').hide();
            }

            // If user selects labcorp vendor then show e-ordering buttons
            // unless third-Party Bill Type is selected and the patient is
            // missing certain insurance fields required by labcorp.
            // In this case show an alert about why they can't eorder
            var thirdPartyAndMissingFields = Boolean((
                // None ('') defaults to 3rd party in hl7
                (billType === 'thirdparty' || billType === '')
                // address, carrier and member id are required by labcorp
                && !(el8.ptdata.currPatient.getPrimaryInsurance()
                && el8.ptdata.currPatient.getPrimaryInsurance().hasAddressFilledOut()
                && el8.ptdata.currPatient.getPrimaryInsurance().getCarrier()
                && el8.ptdata.currPatient.getPrimaryInsurance().getMemberId())
            ));

            // set our ability to show AOEs based on the orders integration status
            form.getListeditor('tests').setShowAOE(that._ordersIntegrationIsLive());

            // determine if we should show the e-order insurance warning
            if (that._ordersIntegrationIsLive()) {
                if (thirdPartyAndMissingFields &&
                    (vendor.getName().toLowerCase().includes("labcorp") ||
                    (vendor.getName().toLowerCase().includes("care360")))) {
                    // reset height and show warning but allow eorder
                    that.getWarningElt().css('height', 'auto').show();
                    that._showEorderButtons();
                } else {
                    // hide and set height to 0 for adjusting the dialog height correctly
                    that.getWarningElt().css('height', '0px').hide();
                    that._showEorderButtons();
                }
            } else { // hide and set height to 0 for adjusting the dialog height correctly
                that.getWarningElt().css('height', '0px').hide();
                that._hideEorderButtons();
            }
            /* Possible future behavior requested by Product
            if (vendor && vendor.getName().toLowerCase().includes("care360")) {
                // Set the maxlength of the lab instructions (shorter for Quest bidi)
                $('[name=testCenterNotes]')[0].setAttribute('maxLength', '300');
            } else {
                $('[name=testCenterNotes]')[0].removeAttribute('maxLength');
                document.getElementById('testCenterNotesCount').innerHTML = "";
            }
            */
        }
        that.adjustHeight();
    };

    // The interaction between the dropdown and mindreader can sometimes cause a
    // double-open attempt on this modal. We debounce the function here so that
    // the second open request does not result in two modals.
    that._promptForTest = _.debounce(function(val) {
        if (!val || el8.app.shared.dialog.createLabOrderTest.isOpen()) {
          return;
        }

        el8.app.shared.dialog.createLabOrderTest.show({
            defaultLabName: val,
            saveCb: function(data) {
                var lab = el8.data.labOrderTests.create(data);
                var testLe = that.getForm().getListeditor('tests');
                testLe.addEntry(lab);
                testLe.getMindreader().clearCache(); // make the new test show up
            }
        });
    }, 300, true);

    return that;
})();
